import { render, staticRenderFns } from "./BindMixCarrierCards.vue?vue&type=template&id=a2408398&scoped=true&"
import script from "./BindMixCarrierCards.vue?vue&type=script&lang=js&"
export * from "./BindMixCarrierCards.vue?vue&type=script&lang=js&"
import style0 from "./BindMixCarrierCards.vue?vue&type=style&index=0&id=a2408398&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2408398",
  null
  
)

export default component.exports